export default __webpack_public_path__ + "static/media/0000..0006.7d88d9bb.png";